import React, { useState, useEffect } from 'react';
import './MusicaEventi.css';

import elam1 from '../img/elam1.jpg';
import elam2 from '../img/elam2.jpg';
import elam3 from '../img/elam3.jpg';

import os1 from '../img/Outsoon/outsoon1.JPEG'
import os2 from '../img/Outsoon/outsoon2.JPEG'

// import sub from '../img/suburbana.jpg'


const Carousel = ({ images, interval = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const autoplay = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, interval);

    return () => clearInterval(autoplay);
  }, [images.length, interval]);

  return (
    <div className="carousel">
      <div 
        className="carousel__track"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {images.map((img, index) => (
          <div key={index} className="carousel__slide">
            <img src={img.src} alt={img.alt} />
          </div>
        ))}
      </div>
      <div className="carousel__indicators">
        {images.map((_, index) => (
          <span
            key={index}
            className={`carousel__dot ${index === currentIndex ? 'active' : ''}`}
          />
        ))}
      </div>
    </div>
  );
};

const MusicaEventi = () => {
  // Placeholder images - sostituisci con le tue immagini reali
  const elamLivePhotos = [
    { src: elam1, alt: 'Elam Live 1' },
    { src: elam2, alt: 'Elam Live 2' },
    { src: elam3, alt: 'Elam Live 3' },
  ];

  const outsoonEventPhotos = [
    { src: os1, alt: 'Outsoon Event 1' },
    { src: os2, alt: 'Outsoon Event 2' },
  ];

  // const suburbanaPhotos = [
  //   { src: sub, alt: 'Suburbana 1' },
  // ];

  return (
  <section id="musica" className="musica-eventi">
    <div className="musica-eventi__container">
      <h2 className="musica-eventi__title">Musica & Eventi</h2>
      
      {/* Progetto Elam */}
      <div className="musica-eventi__block elam-block">
        <div className="musica-eventi__content">
          <h3 className="musica-eventi__subtitle">Elam</h3>
          <p>
            Accanto al percorso accademico, porto avanti un progetto musicale personale sotto il nome <span className="highlight">Elam</span>. Il progetto comprende attività di <span className="highlight">scrittura e produzione musicale</span>, sviluppate in contesti diversi e attraverso collaborazioni eterogenee. In questo spazio, la musica diventa uno <span className="highlight">strumento di introspezione e ricerca personale</span>, attraverso cui esploro dimensioni espressive intime e narrative, trasformando esperienze vissute in contenuti artistici condivisibili.
          </p>
          <p>
            Questo percorso trova una prima sintesi nell'EP <span className="highlight">"Eppure ci siamo amati tanto"</span>, pubblicato a <span className="highlight">gennaio 2025</span>, un progetto che affronta temi legati all'<span className="highlight">identità, al cambiamento</span> e alla relazione con <span className="highlight">sé stessi e con gli altri</span>. Parallelamente all'attività in studio, il progetto si sviluppa anche attraverso una <span className="highlight">dimensione live</span> che contribuisce a costruire un <span className="highlight">rapporto diretto con il pubblico</span>.
          </p>
          <p>
            Il progetto è seguito da me anche sul piano della <span className="highlight">direzione artistica</span>, con una cura autonoma dell'identità visiva, narrativa e sonora, sviluppata in dialogo con professionisti del settore.
          </p>
          <div className="musica-eventi__links">
            <a 
              href="https://open.spotify.com/intl-it/album/1ipQKz8i0efiHiNVsgXKvG?si=8zSEBvCwQhSofhcgrwG5sw" 
              target="_blank" 
              rel="noopener noreferrer"
              className="musica-eventi__link"
            >
              → Link al disco
            </a>
          </div>
        </div>
        <div className="musica-eventi__carousel-wrapper">
          <Carousel images={elamLivePhotos} interval={3500} />
          <p className="musica-eventi__carousel-caption">Scatti dai live</p>
        </div>
      </div>

      {/* Outsoon - DOM RIORGANIZZATO */}
<div className="musica-eventi__block outsoon-block">
  <div className="musica-eventi__content">
    <h3 className="musica-eventi__subtitle">Outsoon · Eventi</h3>
    <p>
      Parallelamente, faccio parte di <span className="highlight">Outsoon</span> (sezione <span className="highlight">Eventi</span>), un collettivo creativo con sede a Milano con cui collaboro allo <span className="highlight">sviluppo di format musicali, all'organizzazione di eventi e al booking di artisti</span>. L'attività del collettivo è orientata alla creazione di <span className="highlight">spazi ricorrenti e riconoscibili</span> dedicati alla musica emergente, con particolare attenzione alla <span className="highlight">direzione artistica</span> e allo <span className="highlight">sviluppo strategico e creativo</span> dei progetti.
    </p>
    <p>
      Dal 2022 il collettivo sviluppa <span className="highlight">Amore A Milano</span>, un format nato come iniziativa di comunicazione e poi evoluto in uno <span className="highlight">spazio stabile per concerti</span>, scoperta di nuovi talenti e incontro tra artisti emergenti, progetti del roster e pubblico affezionato. Nel tempo, l'evento ha trovato casa prima all'<span className="highlight">Hard Rock Café di Milano</span> e successivamente all'<span className="highlight">ARCA</span>, rafforzando la propria identità come appuntamento ricorrente per la musica emergente e la crescita della community.
    </p>
    <p>
      Da <span className="highlight">marzo 2024</span> contribuisco attivamente allo <span className="highlight">sviluppo del format</span>, partecipando alla realizzazione di circa <span className="highlight">dieci eventi</span> tra Hard Rock Café e ARCA.
    </p>
    <p>
      Da <span className="highlight">gennaio 2026</span> collaboro anche a <span className="highlight">AMAMI</span>, spin-off di Amore A Milano pensato per ampliare il progetto verso nuove direzioni artistiche, offrendo ancora una volta uno spazio ai talenti della nuova scena musicale.
    </p>
  </div>
  
  {/* Carousel DOPO il contenuto nel DOM */}
  <div className="musica-eventi__carousel-wrapper">
    <Carousel images={outsoonEventPhotos} interval={4000} />
    <p className="musica-eventi__carousel-caption">Scatti degli eventi</p>
  </div>
</div>


      {/* Suburbana */}
      {/* <div className="musica-eventi__block suburbana-block">
        <div className="musica-eventi__content">
          <h3 className="musica-eventi__subtitle">Suburbana</h3>
          <p>
            Più recentemente, questi percorsi confluiscono in <span className="highlight">SUBURBANA</span>, un ecosistema culturale progettato per valorizzare i talenti emergenti, creare connessioni tra persone e territori e restituire alla città un ruolo attivo nella produzione culturale. Non è solo un festival, ma un <span className="highlight">processo continuativo di scoperta e relazione tra musica, spazio urbano e community</span>, con radici nella mia terra, la <span className="highlight">Calabria</span>.
          </p>
          <p>
            <span className="highlight">SUBURBANA MUSIC FEST</span> rappresenta il momento di massima intensità del progetto: un boutique showcase festival urbano, caratterizzato da una <span className="highlight">forte curatela artistica</span>, un formato intimo e un <span className="highlight">focus sulla scoperta di nuovi talenti</span>, affiancata a occasioni di networking con professionisti dell'industria musicale.
          </p>
          <p>
            <span className="highlight">SUBURBANA ECHO</span> è il pilastro digitale dell'ecosistema: una <span className="highlight">piattaforma attiva tutto l'anno</span> che struttura i processi di scouting, raccoglie e diffonde contenuti editoriali e mantiene viva la community, garantendo continuità tra l'esperienza online e i momenti dal vivo.
          </p>
        </div>
      </div> */}

      {/* Conclusione */}
      <div className="musica-eventi__conclusion">
        <p>
          Nel complesso, considero la musica non come un'attività separata, ma come una <span className="highlight">dimensione complementare al mio futuro percorso professionale</span>, capace di rafforzare un <span className="highlight">approccio ibrido basato su creatività, progettazione e visione strategica</span>.
        </p>
      </div>
    </div>
  </section>
);
}

export default MusicaEventi;
